import React from 'react';

const TopLeft2Shape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="241" 
      height="241"
      viewBox="0 0 241 241" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
    <path 
      d="M61.1858 240.293C279.469 143.768 253.419 -38.7323 213.109 -117.917L19.866 -114.43L8.78813 -85.069C-20.4004 142.429 31.558 226.63 61.1858 240.293Z" 
      fill="white"
    />
    </svg>
  );
};

export default TopLeft2Shape;
